"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./FixedTooltip.css");
var icons = require("./../../../../styles/att-icons.css");
var OnClickOutside_1 = require("../../../behaviors/OnClickOutside/OnClickOutside");
var FixedTooltip = /** @class */ (function (_super) {
    __extends(FixedTooltip, _super);
    function FixedTooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { showTooltip: false };
        _this.idName = "fixedTooltip" + FixedTooltip.counter++;
        _this.toggleTooltip = _this.toggleTooltip.bind(_this);
        _this.closeTooltip = _this.closeTooltip.bind(_this);
        return _this;
    }
    FixedTooltip.prototype.showTooltipTip = function () {
        if (this.props.options && this.props.options.isRennyStyle) {
            return this.state.showTooltip ? styles.showTooltipTipRenny : '';
        }
        else {
            return this.state.showTooltip ? styles.showTooltipTip : '';
        }
    };
    FixedTooltip.prototype.getTooltipWidthStyles = function () {
        return {
            right: this.props.options && this.props.options.growRight ? 'auto' : '0',
            width: this.props.options && this.props.options.width ? this.props.options.width : '100%',
        };
    };
    FixedTooltip.prototype.render = function () {
        return this.getClickType();
    };
    FixedTooltip.prototype.getClickType = function () {
        var cssClasses = [
            styles.fixedTooltipContainer,
            this.props.options.className,
        ];
        return (React.createElement("div", { className: cssClasses.join(' ') },
            !this.props.data.isControlled && this.getButtonForUncontrolled(),
            React.createElement("div", __assign({ "data-test-id": this.props.testId, tabIndex: 0, className: this.getContentClasses() }, this.getContentAccessibility(), { style: this.getTooltipWidthStyles() }), this.props.children)));
    };
    FixedTooltip.prototype.getContentClasses = function () {
        return [this.props.options && this.props.options.isRennyStyle ? styles.tooltipContentRenny : styles.tooltipContent,
            this.props.options.className,
            this.shouldShowTooltip() ? styles.show : '',
            this.props.data.isControlled ? styles.controlled : '',
        ].join(' ');
    };
    FixedTooltip.prototype.getContentAccessibility = function () {
        return {
            'aria-hidden': !this.shouldShowTooltip(),
            'aria-live': 'polite',
            id: this.idName,
        };
    };
    FixedTooltip.prototype.shouldShowTooltip = function () {
        return this.props.data.isControlled ? this.props.data.showTooltip : this.state.showTooltip;
    };
    FixedTooltip.prototype.getButtonForUncontrolled = function () {
        return (React.createElement("button", __assign({ className: [this.props.options && this.props.options.isRennyStyle ? styles.tooltipButtonRenny : styles.tooltipButton, this.showTooltipTip()].join(' '), onClick: this.toggleTooltip, onBlur: this.closeTooltip }, this.getButtonAccessibility()),
            this.props.options && this.props.options.isRennyStyle ? (React.createElement("i", { className: [icons.attIcon, icons.attIconNumbersLettersFlatFaq, styles.iconStylesRenny].join(' ') })) :
                React.createElement("i", { className: [icons.attIcon, icons.attIconNumbersLettersFlatFaq, styles.iconStyles].join(' ') }),
            this.state.showTooltip ? (React.createElement(OnClickOutside_1.default, { events: { onClickOutside: this.closeTooltip } })) : null));
    };
    FixedTooltip.prototype.getButtonAccessibility = function () {
        var showTooltip = this.shouldShowTooltip();
        return Object.assign({
            'aria-expanded': showTooltip,
            'aria-label': 'Onclick tooltip label Help',
        }, showTooltip ? { 'aria-describedby': this.idName } : {});
    };
    FixedTooltip.prototype.toggleTooltip = function () {
        this.setState({ showTooltip: !this.state.showTooltip });
    };
    FixedTooltip.prototype.closeTooltip = function () {
        this.setState({ showTooltip: false });
    };
    FixedTooltip.counter = 0;
    return FixedTooltip;
}(React.Component));
exports.default = FixedTooltip;
//# sourceMappingURL=FixedTooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/FixedTooltip/FixedTooltip.js
// module id = 515
// module chunks = 8